import { React } from 'react';
import { FaAngleUp } from 'react-icons/fa';
import './App.css';
import About from './component/About';
import Contact from './component/Contact';
import Experience from './component/Experience';
import Footer from './component/Footer';
import Header from './component/Header';
import MyTitle from './component/MyTitle';
import Navbar from './component/Navbar';
import Portfolio from './component/Portfolio';
import Services from './component/Services';
function App() {
  let angleUp = document.getElementById('angle-up');

  window.addEventListener('scroll', () => {
    angleUp.classList.toggle('angle-up-active', window.scrollY > 300);
  })
  return (
    <>
      <div className='container-xxl'>
        <Navbar />
        <Header />
        <About />
        <Services />
        <Experience />
        <Portfolio />
        <MyTitle />
        <Contact />
        <Footer />
        <a href="#header" className='angle-up' id='angle-up'>
          <FaAngleUp />
        </a>
      </div>
    </>
  );
}

export default App;